/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popSell.vue?vue&type=template&id=6acd451f"
import script from "./popSell.vue?vue&type=script&lang=js"
export * from "./popSell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports